import { defineMessages } from 'react-intl';

export default defineMessages({
    retrievingDraftSubmission: {
        id: 'ml.quoteandbind.common.MLQuoteEntry.Retrieving draft submission...',
        defaultMessage: 'Retrieving draft submission...'
    },
    technicalDifficulties: {
        id: 'ml.quoteandbind.common.MLQuoteEntry.technicalDifficulties',
        defaultMessage: 'We’re sorry. Due to technical difficulties, we are unable to process your quote at this time. Please try again later. Thank you.'
    },
    closeWindow: {
        id: 'ml.quoteandbind.common.MLQuoteEntry.Close window',
        defaultMessage: 'Close window'
    },
    unableToProceed: {
        id: 'ml.quoteandbind.common.MLQuoteEntry.unableToProceed',
        defaultMessage: 'We’re sorry, we are unable to proceed with your request to quote {policyType} product online. Please call us at 1-800-332-0460 to complete a quote.'
    },
    mlAuto: {
        id: 'ml.quoteandbind.root.LandingPage.an auto',
        defaultMessage: 'an auto'
    },
    mlHomeowners: {
        id: 'ml.quoteandbind.root.LandingPage.a home',
        defaultMessage: 'a home'
    },
    mlUmbrella: {
        id: 'ml.quoteandbind.root.LandingPage.an umbrella',
        defaultMessage: 'an umbrella'
    },
    mlPeriodStartDatePopupTitle: {
        id: 'ml.quoteandbind.landingPage.periodStartDate.Do you want to change the effective date of your quote?',
        defaultMessage: 'Do you want to change the effective date of your quote?',
    },
    mlGPAPeriodStartDatePopupTitle: {
        id: 'ml.quoteandbind.views.period-start-date-dialog.Please review the effective date as it\'s a date in the past',
        defaultMessage: 'Please review the effective date as it\'s a date in the past'
    },
    mlDatabaseBeanVersionConflictMessage: {
        id: 'ml.quoteandbind.common.MLQuoteEntry.databaseBeanVersionConflictMessage',
        defaultMessage: 'The System is experiencing simultaneous updates for this quote. Please wait a few seconds and continue'
    }
});
